import anime, {AnimeInstance} from 'animejs'
import {Component, ConnectedComponent} from 'lowkey-component'

import {createNavState} from '@services/NavState'
import {WindowService} from '@services/WindowService'
import {colors} from '@services/utils'
import {appSelectors} from '@store/appSlice'

export class HeaderNav extends ConnectedComponent {
  private links: Component[] = [];
  private menus: Component[] = [];
  private backdrop: HTMLDivElement | null | undefined = undefined;
  private windowService = WindowService.create();
  private downAnime: AnimeInstance | null = null;
  private upAnime: AnimeInstance | null = null;
  private contents: HTMLDivElement | undefined = undefined;
  private navState = createNavState();

  constructor(element: HTMLDivElement) {
    super(element);
  }

  didMount() {
    this.contents = document.querySelector(
      '.o-header-nav-contents',
    ) as HTMLDivElement;

    this.observe(appSelectors.selectPageIndicatorStatus, (status) => {
      if (status === 'startHideAnimation') {
        this.hidden();
        this.hiddenBackdrop();
        this.element.style.pointerEvents = 'auto';
        this.contents && (this.contents.style.pointerEvents = 'auto');
        this.upAnime = anime({
          easing: 'easeOutCirc',
          targets: [this.element, this.contents],
          duration: 1000,
          delay: 500,
          opacity: 1,
        });
      }
    });
    // this.observe(navSelectors.selectHeaderNavDisplayState, (state) => {
    //   switch (state) {
    //     case 'fixed':
    //       this.element.classList.add('fixed')
    //       this.element.classList.remove('show')
    //       return
    //     case 'show':
    //       this.element.classList.add('show')
    //       return
    //     case 'absolute':
    //       this.element.classList.remove('fixed')
    //       this.element.classList.remove('show')
    //       return
    //   }
    // });

    // this.observe(appSelectors.selectOneViewStatus, (status) => {
    //   if (status === 'down') {
    //     this.upAnime?.pause()
    //     this.element.style.pointerEvents = 'none'
    //     this.contents && (this.contents.style.pointerEvents = 'none')
    //     this.downAnime = anime({
    //       easing: 'easeOutCirc',
    //       targets: [this.element, this.contents],
    //       duration: 1000,
    //       opacity: 0,
    //     })
    //   } else if (status === 'up') {
    //     this.downAnime?.pause()
    //     this.element.style.pointerEvents = 'auto'
    //     this.contents && (this.contents.style.pointerEvents = 'auto')
    //     this.upAnime = anime({
    //       easing: 'easeOutCirc',
    //       targets: [this.element, this.contents],
    //       duration: 1000,
    //       delay: 500,
    //       opacity: 1,
    //     })
    //   }
    // })
    //

    const links = [
      ...this.element.querySelectorAll('.o-header-nav_item'),
    ] as HTMLDivElement[];
    this.links = links.map((link) => {
      const c = new Component(link);
      c.mount();
      return c;
    });

    const menus = [
      ...document.querySelectorAll('.o-header-nav-contents_menu'),
    ] as HTMLDivElement[];
    this.menus = menus.map((m) => {
      const c = new Component(m);
      c.mount();
      return c;
    });

    this.backdrop = document.querySelector(
      '.o-header-nav-contents_backdrop',
    ) as HTMLDivElement;

    this.links.map((link, index) => {
      link.on('mouseenter', () => {
        this.hidden();
        this.show(index + 1);
      });
    });

    this.menus.map((menu) => {
      menu.on('mouseleave', () => {
        this.hidden();
        this.hiddenBackdrop();
      });
    });

    // this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
    //   if (status === 'startHideAnimation') {
    //     this.element?.classList.add('viewed');
    //   }
    // });

    this.resize();

    this.windowService.onResize.connect(this.onResize);
  }

  didUnmount() {
    this.windowService.onResize.disconnect(this.onResize);
    this.links.map((item) => {
      item.destroy();
    });
    this.menus.map((item) => {
      item.destroy();
    });
  }

  onResize = () => {
    this.resize();
  };

  resize() {
    let ret = 0;
    this.menus.map((menu) => {
      const {height = 0} = menu.element?.getBoundingClientRect() || {};
      if (ret < height) {
        ret = height;
      }
    });
    if (this.backdrop) {
      this.backdrop.style.height = `${ret}px`;
    }

    this.links.map((link, index) => {
      const {left = 0} = link.element?.getBoundingClientRect() || {};

      const menu = this.getMenu(index + 1);
      if (menu && menu.element) {
        menu.element.style.left = `${left}px`;
      }
    });
  }

  getMenu(index: number) {
    return this.menus.find((menu) => {
      const dataIndex = Number(menu.element?.dataset['index']);
      return index === dataIndex;
    });
  }

  show(index: number) {
    const menu = this.getMenu(index);
    if (!menu) {
      this.hiddenBackdrop();
      return;
    }
    // if (menu.element) {
    //   menu.element.style.visibility = 'visible'
    // }
    anime({
      // delay: 100,
      duration: 300,
      easing: 'easeOutCubic',
      opacity: 1,
      targets: this.backdrop,
    });
    anime({
      duration: 300,
      easing: 'easeOutCubic',
      opacity: 1,
      targets: menu.element,
    });
    if (menu.element) {
      menu.element.style.visibility = 'visible';
      this.element.style.color = colors.white;
      this.element.style.backgroundColor = colors.black;
      this.navState.updateIsShowHeaderNavMenu(true);
    }
  }

  hidden() {
    this.menus.map((menu) => {
      anime({
        duration: 300,
        easing: 'easeOutCubic',
        opacity: 0,
        targets: menu.element,
        visibility: 'hidden',
      });
      if (menu.element) {
        menu.element.style.visibility = 'hidden';
        this.element.style.color = '';
        this.element.style.backgroundColor = colors.white;
        this.navState.updateIsShowHeaderNavMenu(false);
      }
    });
  }

  hiddenBackdrop() {
    anime({
      // delay: 100,
      duration: 300,
      easing: 'easeOutCubic',
      opacity: 0,
      targets: this.backdrop,
    });
  }
}
